import { Observable, of } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TServiceResult } from '@shared/helper/t-service-result';
import { LocalRepository } from '@shared/helper/local-repository';
import { HttpBaseService } from '../base_services/http_base.service';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})

export class StatisticsAggrigatorService extends HttpBaseService {

  public static ProfileStatistics: statisticsModel;

  // private static _userStatistics: statisticsModel;

  // public static get userStatistics() {
  //   return StatisticsAggrigatorService.userStatistics;
  // }

  constructor() {
    const http = inject(HttpClient);
    const repo = inject(LocalRepository);

    super(repo, http, 'v1/stAggr');
  }

  getMyProfileStatistics(): Observable<TServiceResult<statisticsModel>> {
    if (StatisticsAggrigatorService.ProfileStatistics) {
      return of(new TServiceResult<statisticsModel>(StatisticsAggrigatorService.ProfileStatistics, '', null, false, ''))
    }
    return this.http.get<TServiceResult<statisticsModel>>(`${this.apiUrl}/GetMyProfileStatistics`).pipe(
      tap(res => {
        StatisticsAggrigatorService.ProfileStatistics = res.result;
      })
    );
  }

  getGuestProfileStatistics(userId: string): Observable<TServiceResult<statisticsModel>> {
    return this.http.get<TServiceResult<statisticsModel>>(`${this.apiUrl}/GetGuestProfileStatistics/${userId}`)
      .pipe(
        catchError(() => {
          return of(new TServiceResult<statisticsModel>(new statisticsModel(), '', null, true, ''))
        })
      )
  }

}


export class statisticsModel {
  shelvedBooksCount?: number;
  readBooksCount?: number;
  currentlyReadingBooksCount?: number;
  wantToReadBooksCount?: number;
  addedBooksCount?: number;
  clubsCount?: number;
  reviewsCount?: number;
  ratesCount?: number;
  reviewRatesCount?: number;
  postsCount?: number;
  bookListsCount?: number;
  followersCount?: number;
  followingsCount?: number;
  userScore?: number;
}
